module.exports = __webpack_public_path__ + "img/03623e9.svg";